import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function UploadISEE(props) {
  const apiToken = useContext(TokenContext);
  const [cookies] = useCookies();
  const [value, setValue] = useState();
  const [uploadISEE, setUploadISEE] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    if (data != null) {
      const timer = setTimeout(() => {
        setLoading(true);
        setIsAlertVisible(false);

        window.location.href = props.subfolder + "/home";
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isAlertVisible, data]);

  const sendISEE = async () => {
    setValidation(true);
    setValidationISEE(true);

    let passedValidation = true;

    let tempData = {};
    const d = moment();

    if (uploadISEE) {
      var splitBase64 = uploadISEE.split(",");
      tempData["base64"] = splitBase64[1];
    } else {
      passedValidation = false;
      setValidationISEE(false);
    }

    var localFormat = "YYYY-MM-DD[T]HH:mm:ss";

    tempData["year"] = d.year();
    tempData["date"] = d.format(localFormat);

    if (value == "" || value == " " || !value) passedValidation = false;

    tempData["value"] = value?.replace(".", "").replace(",", ".");

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendISEEApi = async () => {
    setLoading(false);

    Repo.postSendIsee(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          setIsAlertVisible(true);

          toggleModal(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  };

  return (
    <div>
      <h1>Nuovo ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Carica un nuovo ISEE. Il nuovo ISEE caricato andrà ad invalidare il valore dell'ISEE precedente</p>
          </div>


      <div className="row">
        <div className="col-lg-8">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setUploadISEE}
                ></UploadFile>
                {uploadISEE && (
                  <object
                    className="mt-5"
                    width="100%"
                    height="900"
                    data={uploadISEE}
                    type="application/pdf"
                  ></object>
                )}
                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
                {validation && !validationISEE ? (
                  <div className="text-danger">
                    Non è stato caricato nessun documento
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 pl-5">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <h6 className="mb-5">Valore ISEE*</h6>
                <div className="row mb-4">
                  <Input
                    id="value"
                    value={value}
                    name="Valore ISEE"
                    onChange={(e) =>
                      setValue(
                        e.target.value.match(number) ? e.target.value : value
                      )
                    }
                    {...(validation &&
                      (value == "" || value == " " || !value) && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => sendISEE()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>
      {isAlertVisible && (
        <>
          <div
            className="alert alert-success"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>
              Il caricamento è avvenuto con successo! Verrai reindirizzato
              all'Home Page.
            </b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </div>
  );
}

export default UploadISEE;
